module.exports = __webpack_public_path__ + "static/media/taking-asthma-control-test.1d10a179.svg";